import React, { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import { isNewYearTree3dEnabled } from './availability';
import { Tree3dBootScreen } from './Tree3dBootScreen';

const NewYearTree3dRoute = lazy(() => import('./NewYearTree3dRoute'));
/** Лаборатория вида ёлки (верхушки, шейдеры хвои): только для подбора, без игрушек и сервера. */
const TreeLabPage = lazy(() => import('./lab/TreeLabPage'));

type Mode = React.ComponentProps<typeof NewYearTree3dRoute>['mode'];
const page = (mode: Mode, fallback: React.ReactNode = <Tree3dBootScreen />) => (
  <Suspense fallback={fallback}><NewYearTree3dRoute mode={mode} /></Suspense>
);

/**
 * Маршруты /new-year-tree-3d/*. Пока продукт только локальный (availability.ts), без включения
 * возвращает null: пути не регистрируются и ведут себя как любой неизвестный адрес.
 * Вызывать как функцию внутри <Routes>, а не как компонент: <Routes> принимает только <Route>/фрагменты.
 */
export function newYearTree3dRoutes(): React.ReactNode {
  if (!isNewYearTree3dEnabled()) return null;
  return (
    <>
      <Route path="/new-year-tree-3d" element={page('manage')} />
      <Route path="/new-year-tree-3d/manage" element={page('manage')} />
      <Route path="/new-year-tree-3d/demo" element={page('demo')} />
      <Route path="/new-year-tree-3d/lab" element={<Suspense fallback={<Tree3dBootScreen />}><TreeLabPage /></Suspense>} />
      <Route path="/new-year-tree-3d/display/:code" element={page('display')} />
      <Route path="/new-year-tree-3d/add/:code" element={page('add')} />
      <Route path="/new-year-tree-3d/draw/:code" element={page('draw')} />
      <Route path="/new-year-tree-3d/capture/:code" element={page('capture')} />
      <Route path="/new-year-tree-3d/print/:code" element={page('print')} />
      <Route path="/new-year-tree-3d/moderate/:code" element={page('moderate')} />
      <Route path="/new-year-tree-3d/moderator/:secret" element={page('moderator')} />
    </>
  );
}
